import React from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from 'moment';
import { Transition, Icon } from 'semantic-ui-react';
import 'moment/locale/pt-br';
import { getMesAno } from '../../../utils/formatador';
moment.locale('pt-BR');

const iniciais = nome =>
  (nome || '?').split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');

const Condominio = ({ condominio, usuario, animation }) => {
  const demo = usuario && usuario.tipo === 'demo';
  const ativo = !demo && condominio.dataPagamento && condominio.dataVencimento
    && moment(condominio.dataVencimento).isAfter(moment());
  const vencido = !demo && condominio.dataPagamento && condominio.dataVencimento && !ativo;
  const status = demo
    ? { texto: 'Demonstração', cls: 'demo' }
    : ativo
      ? { texto: 'Ativo', cls: 'ativo' }
      : vencido
        ? { texto: 'Vencido', cls: 'pendente' }
        : { texto: 'Não ativado', cls: 'pendente' };

  return (
    <Transition duration={!isNaN(animation) ? animation : 500} animation="fade up" transitionOnMount={true}>
      <Link to={`/condominios/${condominio._id}`} className="va-condo-item" aria-label={`Gerenciar ${condominio.nome}`}>
        <div className="va-condo-item-topo">
          <span className="va-condo-item-avatar">{iniciais(condominio.nome)}</span>
          <span className={`va-condo-item-status ${status.cls}`}>{status.texto}</span>
        </div>
        <h3 className="va-condo-item-nome">{condominio.nome}</h3>
        <ul className="va-condo-item-meta">
          <li><Icon name="calendar outline" /> Criado {moment(condominio.createdAt).fromNow()}</li>
          <li>
            <Icon name="clock outline" />
            {condominio.dataVencimento && condominio.dataPagamento
              ? ` Válido até ${getMesAno(condominio.dataVencimento)}`
              : demo ? ' Modo demonstração' : ' Ainda não ativado'}
          </li>
        </ul>
        <span className="va-condo-item-acao">Gerenciar <Icon name="arrow right" /></span>
      </Link>
    </Transition>
  );
};

export default connect(null, {})(Condominio);
